import { Injectable, TemplateRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UiModalComponent } from '@tekman/shared/component/shared';
import { first } from 'rxjs/operators';

type DialogRef<T> = MatDialogRef<UiModalComponent<T>>;
@Injectable({
  providedIn: 'root',
})
export class ModalService<T = undefined> {
  opened$ = this.dialogRef.afterOpened().pipe(first());

  constructor(private readonly dialogRef: DialogRef<T>) {}

  get context() {
    return this.dialogRef.componentInstance.data.context;
  }

  setHeaderText(headerText: string): void {
    this.dialogRef.componentInstance.data.headerText = headerText;
  }

  setTemplate(template: TemplateRef<any>): void {
    this.dialogRef.componentInstance.data.template = template;
  }
}
